/* eslint-disable import/prefer-default-export */
// middleware action key
export const CALL_BB_API = 'Call Browsebox API';
